<template>
    <div>
        <el-form :inline="true"  class="demo-form-inline" size="small" style="text-align: left;margin-top: 5px;height: 30px">
            <el-form-item>
                <el-input v-model="sysMenu.menuName" placeholder="请输入菜单名称" clearable></el-input>
            </el-form-item>
            <el-form-item>
                <el-select v-model="sysMenu.status"  placeholder="菜单状态">
                    <el-option label="正常" value="0"></el-option>
                    <el-option label="停用" value="1"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" size="mini" @click="menuSearch()">查询</el-button>
                <el-button icon="el-icon-refresh" size="mini" @click="resetSearch()">重置</el-button>
            </el-form-item>
        </el-form>
        <el-card class="box-card">
            <div slot="header"  class="clearfix">
                <el-button style="float: left;" type="primary" class="el-icon-circle-plus-outline" @click="handleAdd()">新增</el-button>
            </div>
            <el-table
                    v-if="refreshTable"
                    v-loading="loading"
                    :data="menuList"
                    row-key="menuId"
                    :default-expand-all="isExpandAll"
                    :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
                    empty-text
            >
                <el-table-column prop="menuName" label="菜单名称" :show-overflow-tooltip="true" width="200"></el-table-column>
                <el-table-column prop="icon" label="图标" align="center" width="120">
                    <template slot-scope="scope">
                        <i :class="scope.row.icon" ></i>
                    </template>
                </el-table-column>
                <el-table-column prop="orderNum" label="排序" width="80"></el-table-column>
                <el-table-column prop="menuType" label="权限标识" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="path" label="路由地址"></el-table-column>
                <el-table-column prop="status" label="状态" width="80">
                    <template slot-scope="scope">
                        <el-tag type="success" v-if="scope.row.status==0">正常</el-tag>
                        <el-tag type="danger" v-if="scope.row.status==1">停用</el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="创建时间" align="center" prop="createTime">
                    <template slot-scope="scope">
                        <span>{{scope.row.createTime | dateFormat}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" align="center" class-name="small-padding fixed-width">
                    <template slot-scope="scope">
                        <el-button
                                size="mini"
                                type="text"
                                icon="el-icon-edit"
                                @click="handleUpdate(scope.row)"
                        >修改</el-button>
                        <el-button
                                size="mini"
                                type="text"
                                icon="el-icon-plus"
                                @click="handleAdd(scope.row)"
                        >新增</el-button>
                        <el-button
                                size="mini"
                                type="text"
                                icon="el-icon-delete"
                                @click="handleDelete(scope.row)"
                        >删除</el-button>
                    </template>
                </el-table-column>
            </el-table>

        </el-card>
        <!--        修改新增菜单-->
        <el-dialog :title="title" :visible.sync="isShowEdit" width="680px" append-to-body>
            <el-form ref="form" :model="form" :rules="rules" label-width="100px">
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="上级菜单" prop="parentId">
                            <treeselect
                                    v-model="form.parentId"
                                    :options="menuOptions"
                                    :normalizer="normalizer"
                                    placeholder="选择上级菜单"
                            />
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="菜单类型" prop="menuType">
                            <el-radio-group v-model="form.menuType">
                                <el-radio label="M">目录</el-radio>
                                <el-radio label="C">菜单</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="菜单图标" prop="icon">

                            <template v-if="form.icon!=null">
                                <eIconPicker v-model="form.icon"/>
                            </template>
                            <template v-else>
                                <eIconPicker defaultIcon="el-icon-loading" v-model="form.icon"/>
                            </template>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="菜单名称" prop="menuName">
                            <el-input v-model="form.menuName" placeholder="请输入菜单名称"/>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="显示排序" prop="orderNum">
                            <el-input-number v-model="form.orderNum" controls-position="right" :min="0"/>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12" v-if="form.menuType=='C'">
                        <el-form-item prop="path">
              <span slot="label">
                <el-tooltip content="访问的路由地址，如：`user`，如外网地址需内链访问则以`http(s)://`开头" placement="top">
                <i class="el-icon-question"></i>
                </el-tooltip>
                路由地址
              </span>
                            <el-input v-model="form.path" placeholder="请输入路由地址"/>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item prop="visible">
              <span slot="label">
                <el-tooltip content="选择隐藏则路由将不会出现在侧边栏，但仍然可以访问" placement="top">
                <i class="el-icon-question"></i>
                </el-tooltip>
                显示状态
              </span>
                            <el-radio-group v-model="form.visible" >
                                <el-radio label="0">显示</el-radio>
                                <el-radio label="1">隐藏</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item prop="status">
              <span slot="label">
                <el-tooltip content="选择停用则路由将不会出现在侧边栏，也不能被访问" placement="top">
                <i class="el-icon-question"></i>
                </el-tooltip>
                菜单状态
              </span>
                            <el-radio-group v-model="form.status">
                                <el-radio label="0">正常</el-radio>
                                <el-radio label="1">停用</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click="submitForm">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import Treeselect from '@riophae/vue-treeselect';
    import '@riophae/vue-treeselect/dist/vue-treeselect.css';

    export default {
        components:{
            Treeselect
        },
        data() {
            return {
                menuList:[],//菜单
                // 重新渲染表格状态
                refreshTable: true,
                // 是否展开，默认全部折叠
                isExpandAll: false,
                loading:false,
                sysMenu:{
                    menuName:null,
                    status:null
                },
                //表单窗体显示
                isShowEdit:false,
                //表单数据
                form:{},
                rules: {
                    menuName: [
                        { required: true, message: "菜单名称不能为空", trigger: "blur" }
                    ],
                    orderNum: [
                        { required: true, message: "菜单顺序不能为空", trigger: "blur" }
                    ],
                    path: [
                        { required: true, message: "路由地址不能为空", trigger: "blur" }
                    ]
                },
                // 弹出层标题
                title: "",
                // 菜单树选项
                menuOptions: [],
                menuName:null,
                //菜单状态
                states:[
                    {
                        value: 1,
                        label: "正常"
                    },
                    {
                        value: 0,
                        label: "停用"
                    }
                ],
                showStates:[
                    {
                        value: 1,
                        label: "显示"
                    },
                    {
                        value: 0,
                        label: "隐藏"
                    }
                ],
                icon: '',
            };
        },
        methods: {
            async getMenuList() {
                const {data: res} = await this.$http.get('menu/getMenuListByNeed',{params:{
                        menuName:this.sysMenu.menuName,
                        status:this.sysMenu.status,
                    }});
                this.menuList = res.data;
                console.log(this.menuList)
            },
            async menuSearch() {
                console.log(this.sysMenu);
                this.getMenuList();
            },
            // 取消按钮
            cancel() {
                this.isShowEdit = false;
                this.reset();
            },
            // 表单重置
            reset() {
                this.form = {
                    menuId: 0,
                    parentId: 0,
                    menuName: null,
                    icon: null,
                    menuType: "M",
                    orderNum: 0,
                    visible: "0",
                    status: "0",
                    path:"",
                };
                // this.resetForm("form");
            },
            //表单重置
            // resetForm(refName) {
            //     if (this.$refs[refName]) {
            //         this.$refs[refName].resetFields();
            //     }
            // },
            /** 新增按钮操作 */
            handleAdd(row) {
                this.reset();
                this.getTreeselect();
                if (row != null && row.menuId) {
                    this.form.parentId = row.menuId;
                    this.form.menuType='C';
                } else {
                    this.form.parentId = 0;
                }
                this.isShowEdit = true;
                this.title = "添加菜单";
            },
            /** 提交按钮 */
            submitForm: function () {
                //如果上级菜单不做选择，就默认在第一级添加
                if (this.form.parentId==null){
                    this.form.parentId=0;
                }
                this.$refs["form"].validate(async valid => {
                    if (valid) {
                        console.log(this.form.menuId)
                        if (this.form.menuId!=0 && this.form.menuId != undefined) {
                            console.log(this.form)
                            const {data:res}=await this.$http.post('menu/updateMenu', this.form);
                            console.log(res)
                            if (res.code==200){
                                this.getMenuList();
                                this.isShowEdit = false;
                                top.location.reload();//顶层页面刷新
                                this.$message.success("修改成功");
                                this.reset();//重置表单信息
                            }else if (res.code==50018){
                                this.$message.error('当前菜单下还存在正常使用的数据，不允许关闭！')
                            }else if (res.code==50003){
                                this.$message.error('菜单名称已存在！')
                            }else {
                                this.$message.error('服务异常！请联系后台工作人员！')
                            }
                        } else {
                            const {data: res} = await this.$http.post('menu/insertMenu', this.form);
                            if (res.code == 200){
                                this.getMenuList();
                                this.isShowEdit = false;
                                this.$message.success("新增成功");
                                top.location.reload();//顶层页面刷新
                                this.reset();//重置表单信息
                            }else if (res.code==50003){
                                this.$message.error('菜单名称已存在！')
                            }else {
                                this.$message.error('服务异常！请联系后台工作人员！')
                            }
                        }
                    }
                });

            },
            /** 查询菜单下拉树结构 */
            getTreeselect() {
                this.menuOptions = [];
                const menu = {menuId: 0, parentId:0,menuName: '主类目', children: []};
                menu.children=this.menuList;
                this.menuOptions.push(menu);
            },
            /** 转换菜单数据结构 */
            normalizer(node) {
                if (node.children && !node.children.length) {
                    delete node.children;
                }
                return {
                    id: node.menuId,
                    label: node.menuName,
                    children: node.children
                };
            },
            /** 修改按钮操作 */
            handleUpdate:function (row) {
                console.log(row)
                this.reset();
                this.getTreeselect();
                this.form=row;
                this.title="编辑菜单";
                this.isShowEdit=true;
            },
            /** 删除按钮操作 */
            handleDelete(row) {
                this.$confirm('是否确认删除名称为"' + row.menuName + '"的数据项？这会删除所有的子目录', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(async () => {
                    this.$confirm('你已经被警告过了', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'error'
                    }).then(async () => {
                        const {data:res}=await this.$http.get('menu/delMenuById/' + row.menuId);
                        console.log(res)
                        if (res.code==200){
                            this.getMenuList();
                            this.$message.success('删除成功！')
                            top.location.reload();//顶层页面刷新
                        }else {
                            this.$message.error('出错啦！')
                        }
                    }).catch(() => {
                        this.$message({
                            type: 'info',
                            message: '已取消删除'
                        });
                    });

                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
            //重置搜索框
            resetSearch(){
                this.sysMenu={
                    menuName: null,
                    status: null,
                }
                this.getMenuList();
            }
        },
        mounted() {
            this.getMenuList();
        }
    }
</script>

<style scoped>


</style>
